// extracted by mini-css-extract-plugin
export default {"root":"style_root__xbcKs","icon":"style_icon__pac3O","title":"style_title__fz67S","subtitle":"style_subtitle__PztCq"};